// extracted by css-extract-rspack-plugin
export default {"overlay":"HeaderAgentTasks-module__overlay__hDlmq","stickySkeletonWrapper":"HeaderAgentTasks-module__stickySkeletonWrapper__E8Yon"};